import React from "react";
import { Parser, ProcessNodeDefinitions } from "html-to-react";
import g from "../utils/globals";
import Video from "./Video";
import Img from "./Img";

const reactComponents = {
  video: Video,
  img: Img,
};
const isValidNode = () => true;
const htmlParser = new Parser(React);
const ProcessNodes = new ProcessNodeDefinitions(React);
const resolveSrc = (src, path, ts) => {
  if (/^http/.test(src)) return src;
  let [relativePath, width] = src.split("?");
  const designRatio = width ? +width : 100;
  const devicePixelRatio = Math.min(window.devicePixelRatio, 2);
  const maxWidth = Math.max(window.screen.availHeight, window.screen.availWidth);
  const imwidth = Math.floor((maxWidth * designRatio * devicePixelRatio) / 100);
  return `${g.baseImagesUrl}/${path}${relativePath}?ts=${ts}&imwidth=${imwidth}`;
};

const processingInstructions = ({ path, ts } = {}, staticVideos, noLazy, playingVideos) => [
  {
    shouldProcessNode: node => node.name && reactComponents[node.name],
    processNode: node => {
      const ReactComponent = reactComponents[node.name];
      const parseAttr = attr => {
        switch (attr) {
          case "class":
            return "className";
          case "playsinline":
            return "playsInline";
          case "mutebutton":
            return "muteButton";
          case "singlequality":
            return "singleQuality";
          default:
            break;
        }
      };
      Object.keys(node.attribs).map(attr => {
        if (attr === "class" || attr === "playsinline" || attr === "mutebutton" || attr === "singlequality") {
          node.attribs[parseAttr(attr)] = attr === "mutebutton" || attr === "singlequality" ? true : node.attribs[attr];
          delete node.attribs[attr];
        } else if (attr === "fullscreen") {
          node.attribs[attr] = true;
        }
        return attr;
      });
      const muteButton = node.attribs.muteButton;
      const src = node.name === "img" && path && path.indexOf("figma") > -1 ? resolveSrc(node.attribs.src, path, ts) : node.attribs.src;
      return (
        <ReactComponent
          attrs={{ ...node.attribs, id: node.attribs.id, src }}
          config={{ ...node.attribs, muteButton, src }}
          staticVideos={staticVideos}
          noLazy={noLazy}
          playingVideos={playingVideos}
        />
      );
    },
  },
  {
    shouldProcessNode: () => true,
    processNode: ProcessNodes.processDefaultNode,
  },
];

const ParseHTML = (html, root, staticVideos, noLazy, playingVideos) =>
  htmlParser.parseWithInstructions(html, isValidNode, processingInstructions(root, staticVideos, noLazy, playingVideos));

export default ParseHTML;
